// Import helpers
import { createLinkParams } from 'helpers';
import { getImage } from 'helpers/images';
import { sendFilmEvent } from 'helpers/tracking';

// Import types
import type { SectionContentElement } from 'types/api/sections';
import { ImageType } from 'types/api/images';

const useElementInfo = ({ images, rating, year, genres, subtype, country, previews, title, uuid, context }: SectionContentElement) => {
	const to = createLinkParams({ id: uuid, type: subtype, title });
	const titleImage = getImage(images, [ImageType.Title]);

	const videoId = previews?.preview?.[0]?.videoAssetId;

	const handleGTMEvent = (label = '') => {
		if (subtype === 'vod') {
			sendFilmEvent({ item_name: title, item_variant: rating, release_year: year, country, runtime: context.duration, genres, label });
		}
	};

	return {
		to,
		videoId,
		titleImage,
		handleGTMEvent
	};
};

export default useElementInfo;
